<template>
  <footer class="global-footer">
    <div class="global-footer__left">
      <div class="global-footer__section">
        <span class="global-footer__header">Get website and technical help</span
        ><span
          >Email us at
          <a href="mailto:info@globalcareeraccelerator.org"
            >info@globalcareeraccelerator.org</a
          ></span
        >
      </div>
      <v-divider vertical class="global-footer__divider"></v-divider>
      <div class="global-footer__section">
        <span class="global-footer__header">Learn more about The Global Career Accelerator</span
        ><span
          >Email us at
          <a href="mailto:enrollment@globalcareeraccelerator.org"
            >enrollment@globalcareeraccelerator.org</a
          ></span
        >
      </div>
    </div>
    <span>&copy; 2025 The Global Career Accelerator</span>
  </footer>
</template>

<style scoped>
.global-footer {
  color: #6d6d6d;
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 80px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.global-footer__left {
  display: flex;
  gap: 32px;
}

.global-footer__section {
  display: flex;
  flex-direction: column;
}

.global-footer__header {
  font-weight: 700;
}

a {
  color: inherit;
}

@media (max-width: 768px) {
  .global-footer {
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 24px;
    margin-bottom: 48px;
  }

  .global-footer__left {
    flex-direction: column;
    gap: 24px;
  }

  .global-footer__divider {
    display: none;
  }
}
</style>
